/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllTimeRecords } from '../fn/ranking-endpoints/get-all-time-records';
import { GetAllTimeRecords$Params } from '../fn/ranking-endpoints/get-all-time-records';
import { getChampionList } from '../fn/ranking-endpoints/get-champion-list';
import { GetChampionList$Params } from '../fn/ranking-endpoints/get-champion-list';
import { getLastPlayers } from '../fn/ranking-endpoints/get-last-players';
import { GetLastPlayers$Params } from '../fn/ranking-endpoints/get-last-players';
import { getRankList } from '../fn/ranking-endpoints/get-rank-list';
import { GetRankList$Params } from '../fn/ranking-endpoints/get-rank-list';
import { getRoomChampionList } from '../fn/ranking-endpoints/get-room-champion-list';
import { GetRoomChampionList$Params } from '../fn/ranking-endpoints/get-room-champion-list';
import { RankListItemMessage } from '../models/rank-list-item-message';
import { RankListResponseWrapper } from '../models/rank-list-response-wrapper';

@Injectable({ providedIn: 'root' })
export class RankingEndpointsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRankList()` */
  static readonly GetRankListPath = '/api/namespaces/{nameSpace}/rooms/{roomId}/ranklist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRankList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRankList$Response(params: GetRankList$Params, context?: HttpContext): Observable<StrictHttpResponse<RankListResponseWrapper>> {
    return getRankList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRankList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRankList(params: GetRankList$Params, context?: HttpContext): Observable<RankListResponseWrapper> {
    return this.getRankList$Response(params, context).pipe(
      map((r: StrictHttpResponse<RankListResponseWrapper>): RankListResponseWrapper => r.body)
    );
  }

  /** Path part for operation `getLastPlayers()` */
  static readonly GetLastPlayersPath = '/api/namespaces/{nameSpace}/rooms/{roomId}/lastplayers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLastPlayers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLastPlayers$Response(params: GetLastPlayers$Params, context?: HttpContext): Observable<StrictHttpResponse<RankListResponseWrapper>> {
    return getLastPlayers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLastPlayers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLastPlayers(params: GetLastPlayers$Params, context?: HttpContext): Observable<RankListResponseWrapper> {
    return this.getLastPlayers$Response(params, context).pipe(
      map((r: StrictHttpResponse<RankListResponseWrapper>): RankListResponseWrapper => r.body)
    );
  }

  /** Path part for operation `getRoomChampionList()` */
  static readonly GetRoomChampionListPath = '/api/namespaces/{nameSpace}/rooms/{roomId}/championlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoomChampionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoomChampionList$Response(params: GetRoomChampionList$Params, context?: HttpContext): Observable<StrictHttpResponse<RankListResponseWrapper>> {
    return getRoomChampionList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoomChampionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoomChampionList(params: GetRoomChampionList$Params, context?: HttpContext): Observable<RankListResponseWrapper> {
    return this.getRoomChampionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<RankListResponseWrapper>): RankListResponseWrapper => r.body)
    );
  }

  /** Path part for operation `getChampionList()` */
  static readonly GetChampionListPath = '/api/namespaces/{nameSpace}/championlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChampionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChampionList$Response(params: GetChampionList$Params, context?: HttpContext): Observable<StrictHttpResponse<RankListResponseWrapper>> {
    return getChampionList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChampionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChampionList(params: GetChampionList$Params, context?: HttpContext): Observable<RankListResponseWrapper> {
    return this.getChampionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<RankListResponseWrapper>): RankListResponseWrapper => r.body)
    );
  }

  /** Path part for operation `getAllTimeRecords()` */
  static readonly GetAllTimeRecordsPath = '/api/namespaces/{nameSpace}/alltimerecords';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTimeRecords()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTimeRecords$Response(params: GetAllTimeRecords$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RankListItemMessage>>> {
    return getAllTimeRecords(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTimeRecords$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTimeRecords(params: GetAllTimeRecords$Params, context?: HttpContext): Observable<Array<RankListItemMessage>> {
    return this.getAllTimeRecords$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RankListItemMessage>>): Array<RankListItemMessage> => r.body)
    );
  }

}
